export default __webpack_public_path__ + "static/media/kebeb.64c77768.png";